/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Workout_ComposingInputs */

const en_us2_quick_workout_composing = /** @type {(inputs: Quick_Workout_ComposingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Building…`)
};

const pt_br2_quick_workout_composing = /** @type {(inputs: Quick_Workout_ComposingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montando…`)
};

const es_419_quick_workout_composing = /** @type {(inputs: Quick_Workout_ComposingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Armando…`)
};

const pt_pt2_quick_workout_composing = /** @type {(inputs: Quick_Workout_ComposingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A montar…`)
};

const fr_fr2_quick_workout_composing = /** @type {(inputs: Quick_Workout_ComposingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Création…`)
};

const de_de2_quick_workout_composing = /** @type {(inputs: Quick_Workout_ComposingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird erstellt…`)
};

const it_it2_quick_workout_composing = /** @type {(inputs: Quick_Workout_ComposingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creazione…`)
};

/**
* | output |
* | --- |
* | "Building…" |
*
* @param {Quick_Workout_ComposingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_composing = /** @type {((inputs?: Quick_Workout_ComposingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_ComposingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_composing(inputs)
	if (locale === "es-419") return es_419_quick_workout_composing(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_composing(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_composing(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_composing(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_composing(inputs)
	return en_us2_quick_workout_composing(inputs)
});
export { quick_workout_composing as "quick-workout.composing" }